import { render, staticRenderFns } from "./CartsDrawerFooter.vue?vue&type=template&id=41a6481e&scoped=true"
import script from "./CartsDrawerFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartsDrawerFooter.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CartsDrawerFooter.vue?vue&type=style&index=0&id=41a6481e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a6481e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CBtnSecondary: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/components/CBtnSecondary/CBtnSecondary.vue').default,CIcon: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CIcon/CIcon.vue').default,CBtnPrimary: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/components/CBtnPrimary/CBtnPrimary.vue').default})
